import React from 'react';
import { formatMoney, roundNumber } from '@/lib/formatUtils';
import { FormFieldV2 } from '../form-field-v2';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

export interface SummaryField {
  name: string;
  label: string;
  value?: number | string;
  precision?: number;
  type?: 'text' | 'checkbox';
  className?: string; // Class wrapper around the field item
  labelClassName?: string;
  inputClassName?: string;
  disabled?: boolean;
  hidden?: boolean;
}

export interface SummaryColumn {
  fields: SummaryField[];
  className?: string; // Class wrapper around the column
}

export interface BottomSummaryBarV2Props {
  columns: SummaryColumn[];
  minWidth?: string;
  className?: string;
}

export function BottomSummaryBarV2({ columns, minWidth = '1180px', className }: BottomSummaryBarV2Props) {
  return (
    <div className='min-h-0 w-full flex-none shrink-0 overflow-x-auto overflow-y-visible bg-white px-4 py-2'>
      <div className={cn('flex items-start gap-6 overflow-x-auto overflow-y-hidden', className)} style={{ minWidth }}>
        {columns.map((col, colIdx) => (
          <div key={colIdx} className={cn('flex flex-col gap-1', col.className)}>
            {col.fields.map(field => {
              if (field.hidden) return null;

              const isCheckbox = field.type === 'checkbox';

              return (
                <div key={field.name} className={cn('flex items-center gap-2', field.className)}>
                  {/* Label on the left for text inputs */}
                  {!isCheckbox && (
                    <Label className={cn('w-28 shrink-0 whitespace-nowrap font-medium', field.labelClassName)}>
                      {field.label}
                    </Label>
                  )}

                  <div className={cn(!isCheckbox && 'flex-1')}>
                    <FormFieldV2
                      name={field.name}
                      type={field.type || 'text'}
                      disabled={field.disabled !== false} // Default to disabled for summary fields
                      value={isCheckbox ? undefined : formatMoney(roundNumber(field.value ?? 0, field.precision ?? 0))}
                      className={field.inputClassName}
                    />
                  </div>

                  {/* Label on the right for checkboxes */}
                  {isCheckbox && (
                    <Label className={cn('cursor-pointer font-medium', field.labelClassName)}>{field.label}</Label>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}

export default BottomSummaryBarV2;
